import qs from "qs";
import accountService from "@/services/accountService";
import * as is from "@/utils/is";
import { objToQuery } from "@/utils/index";
import Storage from "@/utils/storage";

/**
 * 根据名字查品牌
 * @param {*} name
 */
export function getAppId(name) {
  return accountService.get(
    `apps/name${objToQuery({
      name,
    })}`
  );
}

/**
 * 查询扫码登录状态,如果已扫码，会返回账户信息
 * @param {*} data
 */
export function queryLoginState(data) {
  const postData = {
    qrcode_key: data.qrcode_key,
    language: data.language,
    type: data.type,
  };
  return accountService.post("/login", qs.stringify(postData));
}

/**
 * 获取微信扫码登录二维码链接
 */
export function getQrCode() {
  return accountService.get("qrcode");
}

/**
 * 手机号邮箱密码登录
 * @param {*} account
 * @param {*} password
 * @param {*} language
 */
export function login(account, password, language) {
  const data = {
    password,
    language,
  };
  if (is.isEmail(account)) {
    data.email = account;
    // 邮箱密码登录类型
    data.type = 4;
  } else {
    data.telephone = account;
    // 手机号密码登录类型
    data.type = 2;
  }
  return accountService.post("/login", qs.stringify(data));
}

/**
 * 通过用户身份identity_token登录
 * @param {*} data
 */
export function loginByToken(identityToken) {
  const postData = {
    identity_token: identityToken,
    type: 15,
  };
  return accountService.post("/login", qs.stringify(postData));
}

/**
 * 手机邮箱验证码登录
 * @param {*} data
 */
export function passwordLessLogin(data) {
  const postData = {
    captcha: data.captcha,
    language: data.language,
  };
  if (data.email) {
    postData.email = data.email;
    postData.type = 3;
  } else {
    postData.telephone = data.telephone;
    postData.country_code = data.country_code;
    postData.type = 1;
  }
  return accountService.post("/login", qs.stringify(postData));
}

/**
 * 注册账号
 * @param {*} data
 */
export function register(data) {
  const postData = {
    password: data.password,
    language: data.language,
    captcha: data.captcha,
  };
  if (data.email) {
    postData.email = data.email;
    postData.type = 3;
  } else {
    postData.telephone = data.telephone;
    postData.country_code = data.country_code;
    postData.type = 1;
  }
  return accountService.post("/register", qs.stringify(postData));
}

/**
 * 修改密码
 * @param {*} data
 */
export function changePassword(data) {
  return accountService.put(
    `/users/${data.user_id}/password`,
    qs.stringify({
      password: data.password,
      password_confirm: data.password_confirm,
    })
  );
}

/**
 * 获取手机地区码
 */
export function getAreaCodes() {
  return accountService.get(
    `country-codes${objToQuery({
      brand: "Apowersoft",
      language: "zh-cn",
    })}`
  );
}
/**
 * 发送验证码
 * @param {*} data
 */
export function captchas(data) {
  return accountService.post("/captcha", qs.stringify(data));
}

/**
 * 重置密码
 * @param {*} data
 */
export function resetPassword(data) {
  return accountService.put("/users/password", qs.stringify(data));
}

/**
 * 验证账号是否已经注册
 * @param {*} data
 */
export function validateAccount(data) {
  return accountService.get(`validation${objToQuery(data)}`);
}

/**
 * 通过第三方应用返回的state登录
 * @param {*} state
 */
export function loginByState(state) {
  return accountService.post(
    "/login",
    qs.stringify({
      state,
      type: 17,
    })
  );
}

/**
 * 获取授权跳转地址
 * account需要根据不同应用传不同的值
 */
export function providerJumpber(language, jump_url, provider, type) {
  const brandId = Storage.get("brandId");
  const appId = Storage.get("appId");
  let account;
  let newProvider;
  if (provider === "dingtalk") {
    account = "apowersoft_v1";
    newProvider = provider;
  } else if (provider === "weixin") {
    newProvider = "wechat";
    account = "v1";
  } else if (provider === "twitter") {
    newProvider = "twitter";
    account = "v1";
  } else {
    account = "default";
    newProvider = provider;
  }
  return accountService.get(
    `login-url${objToQuery({
      is_native: 0,
      account,
      jump_url,
      language,
      provider: newProvider,
      brand_id: brandId,
      app_id: appId,
      type,
    })}`
  );
}
